import React from 'react';
import backgroundImg from '../assets/images/home_page_image.jpeg';

const LeftImageArea = () => {
  return (
    <div
      className="bg order-md-1 ordering-3"
      style={{
        backgroundImage: `url(${backgroundImg})`,
      }}
    ></div>
  );
};

export default LeftImageArea;
